module.exports = __webpack_public_path__ + "6c378017cab3a560c06654c35f038644.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/RO.svg
// module id = 7noj
// module chunks = 0